import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionFormComponent } from './transaction-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { FlexModule } from '@angular/flex-layout';
import { NgxMatIntlTelInputComponent } from '../../../../../../../libs/ngx-mat-intl-tel-input/src/lib/ngx-mat-intl-tel-input.component';
// import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { MatIconModule } from '@angular/material/icon';
import { CustomErrorHandlerService } from '@app/exceptions/custom-error-handler.service';
import { CoreModule } from '@app/core/core.module';
import { SubmitModule } from '@app/core/components/submit/submit.module';
import { SystemIconModule } from './system-icon/system-icon.module';
import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { PagoMovilFormModule } from '../pago-movil-form/pago-movil-form.module';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { TranslateModule } from '@ngx-translate/core';
import { UnsavedChangesDialogModule } from '@app/dashboard/deals/components/unsaved-changes-dialog/unsaved-changes-dialog.module';
import { MessageAlertQuotationHelper } from '@app/transactions/helper/message-alert-quotation.helper';
import { PipesModule } from '../../../core/pipes/pipes.module';

@NgModule({
    declarations: [TransactionFormComponent],
    exports: [TransactionFormComponent],
    providers: [CustomErrorHandlerService, MatDialog, MessageAlertQuotationHelper],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        UnsavedChangesDialogModule,
        // NgxMatIntlTelInputModule,
        NgxMatIntlTelInputComponent,
        MatInputModule,
        MatButtonModule,
        FlexModule,
        MatIconModule,
        SubmitModule,
        MatAutocompleteModule,
        MatDialogModule,
        PagoMovilFormModule,
        SystemIconModule,
        MatSelectModule,
        TranslateModule,
        PipesModule,
        MatCheckboxModule
    ],
    bootstrap: [TransactionFormComponent]
})
export class TransactionFormModule {}
